module.exports = __webpack_public_path__ + "assets/img/windmils.a0cade78.png";